import React from "react";
import { Typography } from "antd";
import { CheckCircleFilled } from "@ant-design/icons";

const { Text } = Typography;

interface DistanceFilterCardsProps {
  distances: string[];
  selected?: string;
  onSelect: (distance: string | undefined) => void;
  savedRanges?: Record<string, any>;
  totalByDistance?: Record<string, number>;
}

const DistanceFilterCards: React.FC<DistanceFilterCardsProps> = ({
  distances,
  selected,
  onSelect,
  savedRanges = {},
  totalByDistance = {},
}) => {
  if (distances.length === 0) return null;

  return (
    <div className="mb-2">
      <div className="flex items-center gap-2 mb-3">
        <Text
          type="secondary"
          className="text-xs font-semibold uppercase tracking-wider"
        >
          Distance
        </Text>
      </div>

      <div className="flex flex-wrap gap-2 sm:gap-3">
        {distances.map((d) => {
          const isSelected = selected === d;
          // Check if ANY ticket for this distance has a saved range
          const hasRange = Object.keys(savedRanges).some((k) =>
            k.startsWith(`${d}___`) || k === d,
          );
          const count = totalByDistance[d];

          return (
            <div
              key={d}
              role="button"
              tabIndex={0}
              onClick={() => onSelect(isSelected ? undefined : d)}
              onKeyDown={(e) => e.key === "Enter" && onSelect(isSelected ? undefined : d)}
              style={{
                position: "relative",
                cursor: "pointer",
                borderRadius: 12,
                padding: "10px 16px",
                minWidth: 90,
                textAlign: "center",
                userSelect: "none",
                transition: "all 0.18s ease",
                borderWidth: isSelected ? 2 : 1.5,
                borderStyle: "solid",
                borderColor: isSelected ? "#3b82f6" : "#e2e8f0",
                backgroundColor: isSelected ? "#eff6ff" : "#ffffff",
                boxShadow: isSelected
                  ? "0 2px 8px rgba(59,130,246,0.2)"
                  : "0 1px 3px rgba(0,0,0,0.06)",
              }}
            >
              {hasRange && (
                <CheckCircleFilled
                  style={{ position: "absolute", top: 6, right: 6, color: "#16a34a", fontSize: 11 }}
                />
              )}
              <div
                style={{
                  fontWeight: 700,
                  fontSize: 15,
                  lineHeight: 1.3,
                  color: isSelected ? "#1d4ed8" : "#374151",
                }}
              >
                {d}
              </div>
              {count !== undefined ? (
                <div style={{ fontSize: 11, marginTop: 2, color: isSelected ? "#3b82f6" : "#9ca3af" }}>
                  {count} participants
                </div>
              ) : (
                <div style={{ fontSize: 11, marginTop: 2, color: "#9ca3af" }}>
                  Participants
                </div>
              )}
              {isSelected && (
                <div
                  style={{
                    position: "absolute",
                    bottom: -1,
                    left: "50%",
                    transform: "translateX(-50%)",
                    width: 32,
                    height: 3,
                    borderRadius: 2,
                    backgroundColor: "#3b82f6",
                  }}
                />
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default DistanceFilterCards;
